import { render, staticRenderFns } from "./SchemeLabels.vue?vue&type=template&id=422f422a&"
import script from "./SchemeLabels.vue?vue&type=script&lang=js&"
export * from "./SchemeLabels.vue?vue&type=script&lang=js&"
import style0 from "./SchemeLabels.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports